import { Component, Input } from '@angular/core';

@Component({
  selector: `ga1-field-label-dialog`,
  template: `
    <default-dialog [title]="label" [closeButton]="true">
      <div class="field-label-content" *ngIf="info" [innerHTML]="info"></div>

      <div class="field-label-faq" *ngIf="faqs?.length">
        <faq-item *ngFor="let faq of faqs" [faqId]="faq"></faq-item>
      </div>
    </default-dialog>
  `
})
export class GA1FieldLabelDialogComponent {
  @Input() public label:string;
  @Input() public faqs:string[];
  @Input() public info:string;
}